import React, { useState } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Layout as AntLayout, Menu, Avatar, Dropdown, Typography, theme } from 'antd';
import { DashboardOutlined, UserOutlined, TeamOutlined, SafetyCertificateOutlined, BankOutlined, LogoutOutlined, MenuFoldOutlined, MenuUnfoldOutlined } from '@ant-design/icons';
import { useAuthStore } from '@/stores/auth';
import { useNavigate, useLocation } from 'react-router-dom';
import GlobalUserDetailModal from '@/components/GlobalUserDetailModal';
import GlobalUserEditModal from '@/components/GlobalUserEditModal';
import GlobalUserPermissionModal from '@/components/GlobalUserPermissionModal';

// Pages
import Dashboard from '@/pages/Dashboard';
import AccountManagement from '@/pages/account/AccountManagement';
import RoleManagement from '@/pages/role/RoleManagement';
import OrganizationManagement from '@/pages/organization/OrganizationManagement';
import Profile from '@/pages/profile/Profile';

const { Header, Sider, Content } = AntLayout;
const { Title } = Typography;

const Layout: React.FC = () => {
  const [collapsed, setCollapsed] = useState(false);
  const { user, logout } = useAuthStore();
  const navigate = useNavigate();
  const location = useLocation();
  const {
    token: { colorBgContainer },
  } = theme.useToken();

  const menuItems = [
    {
      key: '/dashboard',
      icon: <DashboardOutlined />,
      label: '仪表盘',
    },
    {
      key: '/accounts',
      icon: <UserOutlined />,
      label: '账号管理',
    },
    {
      key: '/roles',
      icon: <TeamOutlined />,
      label: '角色管理',
    },
    {
      key: '/organizations',
      icon: <BankOutlined />,
      label: '组织/机构管理',
    },
    {
      key: '/profile',
      icon: <UserOutlined />,
      label: '个人中心',
    },
  ];

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const userMenuItems = [
    {
      key: 'profile',
      icon: <UserOutlined />,
      label: '个人中心',
      onClick: () => {
        navigate('/profile');
      },
    },
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: '退出登录',
      onClick: handleLogout,
    },
  ];

  return (
    <AntLayout style={{ minHeight: '100vh' }}>
      <Sider
        trigger={null}
        collapsible
        collapsed={collapsed}
        width={200}
        style={{
          height: '100vh',
          position: 'fixed',
          left: 0,
          top: 0,
          zIndex: 10,
          overflow: 'auto',
        }}
      >
        <div
          style={{
            height: 64,
            margin: 16,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Title level={4} style={{ color: 'white', margin: 0 }}>
            {collapsed ? 'C' : 'Ocash'}
          </Title>
        </div>
        <Menu theme="dark" mode="inline" selectedKeys={[location.pathname]} items={menuItems} onClick={({ key }) => navigate(key)} />
      </Sider>

      <AntLayout
        style={{
          marginLeft: collapsed ? 80 : 200,
          transition: 'margin-left 0.2s',
        }}
      >
        <Header
          style={{
            position: 'fixed',
            top: 0,
            left: collapsed ? 80 : 200,
            width: `calc(100% - ${collapsed ? 80 : 200}px)`,
            zIndex: 100,
            height: 64,
            padding: '0 16px',
            background: colorBgContainer,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            transition: 'left 0.2s, width 0.2s',
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center' }}>
            {React.createElement(collapsed ? MenuUnfoldOutlined : MenuFoldOutlined, {
              className: 'trigger',
              onClick: () => setCollapsed(!collapsed),
              style: { fontSize: '18px', cursor: 'pointer' },
            })}
          </div>

          <Dropdown menu={{ items: userMenuItems }} placement="bottomRight">
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                cursor: 'pointer',
                padding: '0 8px',
              }}
            >
              <Avatar icon={<UserOutlined />} style={{ marginRight: 8 }} />
              <span>{user?.username}</span>
            </div>
          </Dropdown>
        </Header>

        <Content
          style={{
            margin: '24px 16px',
            padding: 24,
            minHeight: 280,
            background: colorBgContainer,
            borderRadius: 8,
            paddingTop: 20,
            marginTop: 84, // 防止内容被固定Header遮挡
          }}
        >
          <Routes>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/accounts" element={<AccountManagement />} />
            <Route path="/roles" element={<RoleManagement />} />
            <Route path="/organizations" element={<OrganizationManagement />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </Content>
      </AntLayout>

      {/* 全局弹窗组件 */}
      <GlobalUserDetailModal />
      <GlobalUserEditModal />
      <GlobalUserPermissionModal />
    </AntLayout>
  );
};

export default Layout;
